/** File name (last path segment) from a URL or path, ignoring the query string; fallback used when none found. */
function getFileNameFromUrl(url: string, fallback: string) {
  return url.split('?')[0].split('/').pop() || fallback
}

/** Extension (with leading dot) from a URL or path, ignoring the query string; fallback used when none found. */
export function getExtensionFromUrl(url: string, fallback: string) {
  const fileName = getFileNameFromUrl(url, '')
  const dotIndex = fileName.lastIndexOf('.')
  return dotIndex > 0 ? fileName.slice(dotIndex) : `.${fallback}`
}

// Long enough for a slow browser to finish reading the blob; revoking right after the click can cancel the download.
const OBJECT_URL_LIFETIME_MS = 40_000

/** Saves an object URL (from URL.createObjectURL) to disk via a transient anchor, then revokes it. */
export function downloadFromObjectUrl(objectUrl: string, fileName: string) {
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_LIFETIME_MS)
}

/** Fetches a file from a URL and triggers a browser download; filename defaults to the URL's basename. */
export async function downloadFromUrl(url: string, fileName?: string) {
  const response = await fetch(url)
  if (!response.ok) throw new Error('Unable to download document.')
  const name = fileName ?? getFileNameFromUrl(url, 'download')
  downloadFromObjectUrl(URL.createObjectURL(await response.blob()), name)
}
